/*
 * This file is part of glowingblue/orell-facade.
 *
 * Copyright (c) 2022 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import AbstractFieldGroup from './AbstractFieldGroup';

export default class Content extends AbstractFieldGroup {
	get isResponsive() {
		return true;
	}

	fields() {
		return [
			{
				name: 'title',
				type: 'textarea',
			},
			{
				name: 'subtitle',
				type: 'textarea',
			},
			{
				name: 'overline',
				type: 'textarea',
			},
			{
				name: 'teaser',
				type: 'textarea',
			},
			{
				name: 'category',
				type: 'textarea',
			},
			{
				name: 'disruptor',
				type: 'textarea',
			},
		];
	}
}
